import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { Column, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import Card from './Card'
import { LIST } from './constants'
import { Container } from './styles'
import Title from './Title'

type Props = {
  onAction?: () => void
}

function WhyDoYouNeedActNowSection({ onAction }: Props) {
  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Container
          flexDirection={['column', 'column', 'column', 'column', 'row']}
          py={80}
        >
          <Column fullWidth gap={13}>
            <Title />

            <Column gap={3}>
              {LIST.map(item => (
                <Text body key={item.id} medium screen20>
                  {item.text}
                </Text>
              ))}
            </Column>

            <Text body regular screen20>
              The only question is: Will you be on the fairway or watching from
              the sidelines?
            </Text>
          </Column>

          <Card onAction={onAction} />
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default WhyDoYouNeedActNowSection
